<template>
  <div
    class="row row--no-grep">
    <div class="col-md-6-12 px-0 d-flex flex-column">
      <span class="melia mb-6">{{ kpi.name }}</span>
      <rir-button
          @click="addNewEvent"
          content-width
          :disabled="isNewEntity"
          color="secondary">
        <rir-icon
            fill="godfather"
            class="mr-2"
            icon="add"
        />
        Добавить происшествие
      </rir-button>

      <event-field-constructor
        v-for="(event, index) in listEvent"
        :key="event.id || index"
        :event="event"
        :index="index"
        @deleteEvent="deleteEvent"
        />
    </div>
  </div>
</template>

<script>
import Kpi from "@/models/Kpi";
import { KpiApi } from '@/api/KpiApi'
import EventFieldConstructor from "@/components/kpiField/EventFieldConstructor";

export default {
  name: 'constructor-form',
  components: {EventFieldConstructor},
  mounted () {
    this.getDataEvent()
  },
  data: () => ({
    listEvent: []
  }),
  props: {
    kpi: {
      type: Object,
      default: () => new Kpi()
    }
  },
  computed: {
    isNewEntity () {
      return this.listEvent.some(el => !el.id)
    }
  },
  methods: {
    addNewEvent () {
      this.listEvent.unshift(this.kpi.createEvent())
    },
    async getDataEvent () {
      const res = await KpiApi.getList({
        parentId: this.kpi.id
      })
      this.listEvent = res.content
    },
    async deleteEvent (data) {
      try {
        const {event, index} = data
        if (event.id) {
          await KpiApi.delete(event.id)
        }
        this.listEvent.splice(index, 1)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
